// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3OwSf","notes":"Notes_notes__1iX6q","note":"Notes_note__2NUbA","markdown":"Notes_markdown__18hj6"};